module.exports = __webpack_public_path__ + "static/media/faq-flow.500c9c41.svg";